import { render, staticRenderFns } from "./index.vue?vue&type=template&id=68b54e14&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b54e14')) {
      api.createRecord('68b54e14', component.options)
    } else {
      api.reload('68b54e14', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=68b54e14&", function () {
      api.rerender('68b54e14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/content/index.vue"
export default component.exports